import { Component, OnInit } from '@angular/core';
import { ProgrammeService } from 'src/app/services/programme.service';
import { iHttpPaginatedResponse } from 'src/app/interfaces/iHttpPaginatedResponse';
import { MatDialog } from '@angular/material/dialog';
import { NewProgrammeComponent } from 'src/app/components/modals/new-programme/new-programme.component';
import { PracticeService } from 'src/app/services/practice.service';
import { Practice } from 'src/app/models/practice';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['./programmes.component.scss']
})
export class ProgrammesComponent implements OnInit {
  public loadedMyProgrammes: boolean = false;
  public myProgrammes: any;
  public memberProgrammes: any;
  public loadedMemberProgrammes:boolean=false;
  public myPractice;

  constructor(
    private programmeService: ProgrammeService,
    public dialog: MatDialog,
    public _practice: PracticeService,
    private _notify: MatSnackBar
  ) {
    this._practice.getMyPractice().subscribe(
      res=>{
        if(res.id) {
          this.myPractice=res;
          this.getMemberProgrammesPlusMetas();
        }
      }
    );
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  getProgrammes(){
    this.programmeService.getMyProgrammesPlusMetas().subscribe(res=>{
      this.myProgrammes = res;
      this.loadedMyProgrammes = true;
    })
  }

  getMemberProgrammesPlusMetas(){
    this.programmeService.getMemberProgrammesPlusMetas().subscribe(
      res=>{
        this.memberProgrammes=res;
        this.loadedMemberProgrammes=true;
      }
    );
  }

  ngOnInit() {
    this.getProgrammes();
  }

  newProgramme(){
    const dialogRef = this.dialog.open(NewProgrammeComponent, {
      width: '450px',
      data: {type:'Personal'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getProgrammes();
        this.notify('Programme added', 'OK');
      }
    });
  }

  newMemberProgramme(){
    const dialogRef = this.dialog.open(NewProgrammeComponent, {
      width: '450px',
      data: {type:'Practice'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getMemberProgrammesPlusMetas();
        this.notify('Programme added', 'OK');
      }
    });
  }

  removePersonalTP(id:number) {
    if(confirm('Confirm you wish to delete this Personal Training Programme.')){
      this.programmeService.deletePTP(id).subscribe(res=>{
        if(res.message=='success') this.getProgrammes();
      }
      );
    }
  }
}
